import React from 'react';

import { TelemetryChildFunctions, TelemetryContextValues } from './TelemetryContexts';

export const telemetryConsumerWrapper = (ContextConsumer: React.Consumer<TelemetryContextValues>, childFunction: TelemetryChildFunctions) =>
  <ContextConsumer>
    {(telemetryHandler: TelemetryContextValues) => telemetryHandler(childFunction)}
  </ContextConsumer>;
